angular.module('logbook')
.directive('busyIndicator', [ '$uibModal', '$http', '$interval', '$sce',
function($uibModal, $http, $interval, $sce) {
  return {
    redirect: 'E',

    scope: {
       'exclusiveRequestPending': '=',
       'maintenanceInfo': '='
    },

	template: require('./busy-indicator.html'),

    link: function(scope, elem, attrs) {
       scope.showWaitMessage = function() {
          if( !scope.modal )
             scope.modal = $uibModal.open({
                templateUrl: 'busy-modal-template.html',
                keyboard: false
             });
       };
       
       scope.$watch('exclusiveRequestPending', function(value) {
          if( scope.modal )
          {
             scope.modal.close();
             delete scope.modal;
          }
       });

       scope.testUser = function()
       {
           $http.get('/api/user', {
              'noIndicator': true,
              'noErrorPopup': true
           }).then(function() { 
              $interval.cancel(scope.checkInterval);
              scope.modal && scope.modal.close();
              delete scope.maintenanceInfo;
              delete scope.modal;
           });
       }

       scope.$on('maintenanceInfo', function(event, value) {
          scope.maintenanceInfo = value;
          scope.maintenanceMessage = $sce.trustAsHtml(
              scope.maintenanceInfo['logbook.maintenance.message'] 
              || 'The system is currently undergoing maintenance.  Please wait...');
          if(value && !scope.modal) {
              scope.modal = $uibModal.open({
                 'templateUrl': 'maintenance-modal-template.html',
                 scope: scope,
                 keyboard: false
              });
              scope.checkInterval = $interval(scope.testUser, 10000);
          }
       });
    }
  }
}]);
